export default{

    signIn: '/api-oauth/oauth2/token', // 登录

    getValidata: '/api-oauth/validata/code', // 获取验证码

    signOut: '/api-oauth/oauth2/logout', // 退出登陆

    getUser: '/api-oauth/oauthclient/getUser', // 获取用户信息

    schemeUrl: '/api-match-signup/signup/manager/scheme/list', // 中心运营 大计划列表

    addschemeUrl:'/api-match-signup/signup/manager/scheme/add', // 中心运营新增计划

    deletescheme: '/api-match-signup/signup/manager/scheme/delete', // 大计划删除

    downLineScheme: '/api-match-signup/signup/manager/scheme/downLine', // 大计划下线

    upLineScheme: '/api-match-signup/signup/manager/scheme/upLine', // 大计划上线

    editGetById: '/api-match-signup/signup/manager/scheme/getById', // 编辑前查询

    editUpdate: '/api-match-signup/signup/manager/scheme/update', // 编辑

    professionListUrl: '/api-match-signup/signup/data/profession/list', // 专业下拉

    orgTypeListUrl: '/api-match-signup/signup/data/orgType/list', // 机构类型下拉

    raceTypeListUrl: '/api-match-signup/signup/data/raceType/list', // 大赛类型下拉

    schemePublish: '/api-match-signup/signup/manager/scheme/publish', // 发布计划

    provinceList: '/api-match-signup/signup/data/province/list', // 省份下拉

    subjectList: '/api-match-signup/signup/data/subject/list', // 科目下拉

    schemeUpdate: '/api-match-signup/signup/manager/scheme/update', // 大计划编辑

    pageListPaper: '/api-match-signup/signup/paper/scheme/pageListPaper', // 试卷管理

    listPagePaper: '/api-match-signup/signup/manager/scheme/listPagePaper', // 试卷管理 添加试卷前的 分页
    
    addBatchPaper: '/api-match-signup/signup/paper/scheme/addBatchPaper', // 试卷管理 添加试卷

    batchDeletePaper: '/api-match-signup/signup/paper/scheme/batchDeletePaper', // 试卷管理 批量删除试卷

    signupApplyPageList: '/api-match-signup/signup/manager/signupApply/pageList', // 中心运营 大计划 机构管理展示分页

    openSignupApply: '/api-match-signup/signup/manager/signupApply/openSignupApply', // 开通机构

    closeSignupApply: '/api-match-signup/signup/manager/signupApply/closeSignupApply', // 停用机构

    pageListApply: '/api-match-signup/signup/saler/pageListApply', // 申报机构的 分页展示

    declareSchemeList: '/api-match-signup/signup/saler/scheme/list', // 申报机构时的 大计划下拉

    dictOrglist: '/api-match-signup/signup/data/dictOrg/list', // 申报机构时的 未被添加进 的机构

    addEndOrgList: '/api-match-signup/signup/saler/addEndOrg/list', // 右侧已经添加的机构

    salerAddApply: '/api-match-signup/signup/saler/addApply', // 批量添加 机构

    removeAddEndOrg: '/api-match-signup/signup/saler/removeAddEndOrg', // 批量移除已经 添加的机构

    commitApply: '/api-match-signup/signup/saler/commitApply', // 批量提交

    commitBack:  '/api-match-signup/signup/saler/commitBack', // 批量撤回

    deleteApply: '/api-match-signup/signup/saler/deleteApply', // 删除申报机构

    getApplyInfoById: '/api-match-signup/signup/saler/getApplyInfoById', // 编辑钱的查询

    updateApply: '/api-match-signup/signup/saler/updateApply', // 编辑

    listApplyPage: '/api-match-signup/signup/manager/listApplyPage', // 机构申请审批 分页

    managerApprove: '/api-match-signup/signup/manager/approve', // 管理员-通过申请

    manageReject: '/api-match-signup/signup/manager/reject', // 驳回申请

    managerListAccount: '/api-match-signup/signup/manager/listAccount', // 查看账号

    managerListAccount2: '/api-match-signup/signup2/apply/orgzhanghao', // 查看账号2

    managerListAccount3: 'api-match-signup/signup/channel/account/list',// 查看账号3

    resetPassword: '/api-match-signup/signup/manager/resetPassword', // 重制密码

    userTypeisValid: '/api-match-signup/signup/user/isValid', // 登录后调的第一个接口获得用户的类型

    dictOrgListPage: '/api-match-signup/signup/data/dictOrg/listPage', // 机构管理

    checkOrgName: '/api-match-signup/signup/data/dictOrg/checkOrgName', // 校验名称是否重复

    updateDictOrg: '/api-match-signup/signup/data/dictOrg/update', // 修改机构信息

    userList: '/api-match-signup/signup/user/list', // 人员列表

    userListUser: '/api-match-signup/signup/user/listUser', // 增加人员时弹框的用户列表

    userlistDept: '/api-match-signup/signup/user/listDept', // 增加人员时弹框的机构列表，

    addUserPerson: '/api-match-signup/signup/user/add', // 增加人员

    removeUser: '/api-match-signup/signup/user/remove', // 移除人员

    subjectJzList: 'api-match-signup/signup/data/subject/jz/list', // 金砖加载科目列表

    importInsOrgList: '/api-match-signup/signup/manager/importOrg', // 批量上传机构，

    importBatchApply: '/api-match-signup/signup/saler/batchApply', // 批量申请机构

    deleteOrg: '/api-match-signup/signup/manager/deleteOrg', // 删除机构

    addOrgList: '/api-match-signup/signup/manager/org/list', // 增加机构时加载不存在于报名系统的机构

    saveBathIns: '/api-match-signup/signup/manager/org/save', // 勾选多条机构点击保存操作

    webApplyPassage: '/api-match-signup/signup2/apply/passage', // 网管注册审批页面

    newWebApplyPassage: `/api-match-signup/signup/channel/list`,// 新的网管注册审批页面

    getOrgQueryApplyOrg: '/api-match-signup/signup2/apply/queryApplyOrg', // 官网注册审批页面内 - 机构信息

    getNewOrgQueryApplyOrg: '/api-match-signup/signup/channel/detail', // 新的 - 官网注册审批页面内 - 机构信息

    setApplyPassorglist: '/api-match-signup/signup2/apply/passorglist', // 批量通过 批量驳回 (弃用)

    setApplyPassorglist2: '/api-match-signup/signup/channel/approve', // 批量通过
 
    setApplyRejectlist: '/api-match-signup/signup/channel/reject', // 批量驳回

    setApplyRegister2: '/api-match-signup/signup2/apply/register2', //单个 审核

    getMatchtypelist: '/api-match-signup/signup2/apply/matchtypelist', //报名官网

    openAndClosePlan: '/api-match-signup/signup2/apply/matchTypestatus', // 开启关闭

    getProfesionlist: '/api-match-signup/signup2/apply/profesionlist', // 报名官网管理 - 专业列表

    getplanlist: '/api-match-signup/signup2/apply/planlist', // 计划列表展示
    
    getpassagelist:'/api-match-signup/signup2/apply/passagelist', // 报名官网管理 - 赛项下拉

    saveUpdateByid: '/api-match-signup/signup2/apply/updateByid', // 编辑 报名官网

    getApplyInterlist: '/api-match-signup/signup2/apply/Interlist', // 注册机构查看

    getApplyEnrollorg: '/api-match-signup/signup2/apply/enrollorg', // 查询运营人员信息 （弃用）

    getProvinceList2: '/api-match-signup/signup2/apply/provinceslist', // 省份下拉2

    getTeamPageShow: '/api-match-signup/signup/channel/teamPageShow', //  查询运营人员信息2

    getAttachList: '/api-match-signup/signup/channel/attach/list', // 获取附件列表

    checkRegisterStatus: `/api-match-signup/signup/channel/orgInfoStatus`, // 获取机构状态
    
    getExport: `/api-match-signup/signup/channel/export`,  // 导出机构申报状态表

    getGroupList:`/api-match-signup/signup/channel/group/list`, // 组别列表

}